import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import moment from "moment";

export default function DefaultProvisionTextContent(props) {
  const { index, data, storeName } = props;

  const [height, setHeight] = useState(0);
  const componentRef = useRef(null);

  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        setHeight(entry.contentRect.height); // 변경된 높이를 상태에 저장
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);
    
    if (componentRef.current) {
      resizeObserver.observe(componentRef.current); // ref를 사용하여 관찰 시작
    }

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <TopLevelWrapper ref={componentRef} isFirst={index === 0}>
      <HistoryTextWrapper width={146}>
        <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' hover='default'>{data.title}</PreText>
      </HistoryTextWrapper>
      <DivisionLine height={height} backgroundColor='#DBDBDB' />
      <HistoryTextWrapper width={950}>
        <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' hover='default'>{data.text.replaceAll('[센터 이름]', storeName)}</PreText>
      </HistoryTextWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  border-top: ${props => props.isFirst ? '0px' : '2px solid #DBDBDB'};
`;

const HistoryTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 18px;

  width: ${props => props.width}px;
`;

const DivisionLine = styled.div`
  width: 2px;
  height: ${props => props.height}px;

  background-color: ${props => props.backgroundColor};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: pre-wrap;

  :hover {
    cursor: ${props => props.hover};
  }
`;